import React from 'react'
import { hot } from 'react-hot-loader/root'
import { Provider } from 'react-redux'
import { ConnectedRouter } from 'connected-react-router';

import 'bootstrap/dist/css/bootstrap.min.css';

import Pages from './asebi/Pages';

import configureStore, { history } from './asebi/store';

const store = configureStore({});
const App = () => (
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <Pages />
    </ConnectedRouter>
  </Provider>
);

export default hot(App);